import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import DataInsights from 'portal/src/components/summary/DataInsights';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from './routeGenerator';

export const summaryRouteDefinitions: RouteDefinition[] = [
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.HOMEPAGE} />,
    name: 'Portfolio',
    path: NESTED_ROUTES.SUMMARY.HOMEPAGE,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.OPPENGINE} />,
    name: 'Savings Opportunities',
    path: NESTED_ROUTES.SUMMARY.OPPENGINE,
  },
  {
    element: <DataInsights />,
    name: 'Data Insights',
    path: NESTED_ROUTES.SUMMARY.DATA_INSIGHTS,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.ENERGY_STAR} />,
    name: 'ENERGY STAR',
    path: NESTED_ROUTES.SUMMARY.ENERGY_STAR,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.EMISSIONS} />,
    name: 'Emissions',
    path: NESTED_ROUTES.SUMMARY.EMISSIONS,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.DATA_COMPLETENESS} />
    ),
    name: 'Data Completeness',
    path: NESTED_ROUTES.SUMMARY.DATA_COMPLETENESS,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.SUMMARY.DATA_RECENCY} />,
    name: 'Data Recency',
    path: NESTED_ROUTES.SUMMARY.DATA_RECENCY,
  },
];
